import { Button, Dropdown } from 'antd'
import { GlobalOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import {
  DEFAULT_LANGUAGE,
  isSupportedLanguage,
  storeLanguage,
  SUPPORTED_LANGUAGES,
  SupportedLanguage,
} from '../../i18n/config'

/**
 * Language names are deliberately NOT translated — a user looking for English
 * needs to recognise "English" while the UI is still in Chinese.
 */
const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  'zh-TW': '繁體中文',
  'en-US': 'English',
}

interface LanguageSwitcherProps {
  /** Hides the label next to the globe icon. Used on narrow layouts. */
  compact?: boolean
}

const LanguageSwitcher = ({ compact = false }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation()

  const current: SupportedLanguage = isSupportedLanguage(i18n.language)
    ? i18n.language
    : DEFAULT_LANGUAGE

  const handleSelect = (language: SupportedLanguage) => {
    void i18n.changeLanguage(language)
    storeLanguage(language)
  }

  return (
    <Dropdown
      placement="bottomRight"
      trigger={['click']}
      menu={{
        selectedKeys: [current],
        items: SUPPORTED_LANGUAGES.map(language => ({
          key: language,
          label: LANGUAGE_LABELS[language],
          onClick: () => handleSelect(language),
        })),
      }}
    >
      <Button type="text" icon={<GlobalOutlined />} aria-label="Language">
        {compact ? null : LANGUAGE_LABELS[current]}
      </Button>
    </Dropdown>
  )
}

export default LanguageSwitcher
